import script from "./LastCase.vue?vue&type=script&setup=true&lang=js"
export * from "./LastCase.vue?vue&type=script&setup=true&lang=js"

import "./LastCase.vue?vue&type=style&index=0&id=1dfdda88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dfdda88"]])

export default __exports__